import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { AppointmentTypesTypes } from '@frontend/api-appointment-types';
import { theme } from '@frontend/theme';
import { ContentLoader, TagType } from '@frontend/design-system';
import { defaultTemplate } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/constant';
import { useManageScheduleRequestModalForm } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/hooks/useManageScheduleRequestModalForm';
import {
  ReducedAppointmentType,
  ReducedOperatory,
  ReducedPractitioner,
} from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/hooks/useReviewRequest';
import {
  SourceTenantListItem,
  WorkstationDropdownList,
} from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/ScheduleRequestModal/types';
import { ActivityHistoryCard } from './ActivityHistoryCard';
import { AppointmentDataCardV3 } from './AppointmentDataCardV3';
import { ApprovalMessageCard } from './ApprovalMessageCard';
import { CustomFieldsCard } from './CustomFieldsCard';
import { PatientInfoCard } from './PatientInfoCard';
import { PaymentInfoCard } from './payment-info-card';

type ReviewAppointmentRequestFormProps = {
  appointmentTypes: AppointmentTypesTypes.AppointmentType[] | ReducedAppointmentType[];
  isLoading: boolean;
  getFieldProps: ReturnType<typeof useManageScheduleRequestModalForm>['scheduleRequestApprovalForm']['getFieldProps'];
  values: ReturnType<typeof useManageScheduleRequestModalForm>['scheduleRequestApprovalForm']['values'];
  dateField: ReturnType<typeof useManageScheduleRequestModalForm>['customDateField'];
  startTimeField: ReturnType<typeof useManageScheduleRequestModalForm>['customStartTimeField'];
  endTimeField: ReturnType<typeof useManageScheduleRequestModalForm>['customEndTimeField'];
  selectedScheduleRequest: ScheduleRequest;
  showSourceLocationDropdown?: boolean;
  providerList: ReducedPractitioner[];
  workstationList: WorkstationDropdownList<ReducedOperatory>;
  isLoadingAvailableWorkstations?: boolean;
  showGroupedWorkstations?: boolean;
  appointmentWritebackSourceTenants?: SourceTenantListItem[];
  showWorkstationDropdown: boolean;
  onTemplateChange: (template: string) => void;
  template: string;
  templateTags: TagType[];
  isReadOnlyTemplate?: boolean;
  isPaymentsEnabled?: boolean;
  paidAmount?: number;
};

export const ReviewAppointmentRequestFormV3 = ({
  isLoading,
  getFieldProps,
  appointmentTypes,
  selectedScheduleRequest,
  values,
  dateField,
  startTimeField,
  endTimeField,
  showSourceLocationDropdown,
  providerList,
  workstationList,
  isLoadingAvailableWorkstations,
  showGroupedWorkstations,
  appointmentWritebackSourceTenants,
  showWorkstationDropdown,
  onTemplateChange,
  template,
  templateTags,
  isReadOnlyTemplate = false,
  isPaymentsEnabled,
  paidAmount,
}: ReviewAppointmentRequestFormProps) => {
  return (
    <>
      <section css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
        <ContentLoader show={isLoading} />
        <PatientInfoCard />
        <CustomFieldsCard />
        <PaymentInfoCard />
        <AppointmentDataCardV3
          getFieldProps={getFieldProps}
          appointmentTypes={appointmentTypes}
          selectedScheduleRequest={selectedScheduleRequest}
          values={values}
          dateField={dateField}
          startTimeField={startTimeField}
          endTimeField={endTimeField}
          showSourceLocationDropdown={showSourceLocationDropdown}
          providerList={providerList}
          workstationList={workstationList}
          isLoadingAvailableWorkstations={isLoadingAvailableWorkstations}
          showGroupedWorkstations={showGroupedWorkstations}
          appointmentWritebackSourceTenants={appointmentWritebackSourceTenants}
          showWorkstationDropdown={showWorkstationDropdown}
          isPaymentsEnabled={isPaymentsEnabled}
          paidAmount={paidAmount}
        />
        <ActivityHistoryCard
          locationId={selectedScheduleRequest.locationId ?? ''}
          bookingSubmissionId={selectedScheduleRequest.id ?? ''}
        />
        <ApprovalMessageCard
          template={template || defaultTemplate}
          templateTags={templateTags}
          onTemplateChange={onTemplateChange}
          isReadOnlyTemplate={isReadOnlyTemplate}
        />
      </section>
    </>
  );
};
